// import { throttle } from 'lodash';

// var $ = require("jquery");
// require("jquery/package.json");

import { smoothScroll } from './functions.js';
// import { scrollToSection } from './functions.js';







function menu_navigation() {

	const menu_toggles = document.querySelectorAll(".menu-toggle");
	const menuItems = document.querySelectorAll('#primary-menu li a');
	const overlay = document.querySelector('.primary-navigation .overlay');
	const html = document.querySelectorAll("html");
	const body = document.querySelectorAll("body");

	function toggleMenu() {
		var value = menu_toggles[0].getAttribute('aria-expanded');
		var aria = value === 'true' ? 'false' : 'true';
		menu_toggles[0].setAttribute('aria-expanded', aria);
		body[0].classList.toggle("toggled");
		menu_toggles[0].classList.toggle("toggled");
		html[0].classList.toggle("lock-scroll");
	}

	// Auto add IDs to sections
	// const sections = document.querySelectorAll('section');
	// sections.forEach((section, index) => {
	// 	if (index > 0) {

	// 		// section.id = 'section-' + (index + 1);
	// 	}
	// });

	// Auto add the correct id's to the href
	menuItems.forEach((menuItem, index) => {
		// const sectionIndex = index + 2;
		// menuItem.href = '#section-' + sectionIndex;
		menuItem.addEventListener('click', (e) => {

			e.preventDefault();
			const targetSectionId = menuItem.getAttribute('href');

			if (window.location.pathname === '/') {
				const targetSection = document.querySelector(targetSectionId);
				// const offset = 100;
				// const targetScrollPosition = targetSection.offsetTop - offset;
				// if (targetSection) {
				// 	// Perform the smooth scroll
				// 	window.scrollTo({
				// 		top: targetScrollPosition,
				// 		behavior: 'smooth'
				// 	});
				// }
			} else {
				// Redirect to the homepage if not already on it
				window.location.href = '/'+targetSectionId;

			}

			toggleMenu();
		});
	});

	// Close menu when clicking hamburger
	menu_toggles.forEach((el) => {
		el.addEventListener('click', () => {
			toggleMenu();
		});
	});

	// Close menu when clicking overlay
	overlay.addEventListener('click', () => {
	  	toggleMenu();
	});
}
window.addEventListener('DOMContentLoaded', menu_navigation);

//
// create sidebar navigation
//
function sideBarNav() {
	var dots = document.querySelector('.sidebar-nav');
	var sections = document.querySelectorAll('.site-main main section');
	let output = '';

	var index = 0;
	sections.forEach(section => {
		output += `<a href="#" data-section-index="${index}" class="dot"></a>`;
		index++;
	});
	dots.innerHTML = output;

	var dots = document.querySelectorAll('.sidebar-nav .dot');

	// prevent default link behaviour
	dots.forEach(dot => {
		dot.addEventListener('click', (e) => {
			e.preventDefault();
		});
	});
}
sideBarNav(); // ???
// window.addEventListener('load', sideBarNav);


//
// Sidebar scroll links
//
import { isElementInView } from './functions.js';

function sidebarDotScrollTo() {
	// Get all the ".dot" elements
	const dots = document.querySelectorAll('.sidebar-nav a.dot');
	// Get all the sections
	const sections = document.querySelectorAll('.site-main main section');
	const offset = 100; // Adjust this value as needed

	function updateActiveDot() {
		sections.forEach((section, index) => {
			if (isElementInView(section)) {
				dots.forEach((dot, dotIndex) => {
					dot.classList.remove('active');
				});
				dots[index].classList.add('active');
			}
		});
	}

	// Function to scroll to the corresponding section when a dot is clicked
	function scrollToSection(index) {
		const targetOffset = sections[index].offsetTop - offset;
		// sections[index].scrollIntoView({ behavior: 'smooth' });
		window.scrollTo({
            top: targetOffset,
            behavior: 'smooth'
        });
	}

	// Add click event listener to each dot
	dots.forEach((dot, index) => {
		dot.addEventListener('click', () => {
			scrollToSection(index);
		});
	});

	// Event listener for scrolling

	updateActiveDot();

	// Event listener for scrolling
	window.addEventListener('scroll', updateActiveDot);

	// Apply active dot class on load
	window.addEventListener('DOMContentLoaded', () => {
		updateActiveDot();
	});
}
sidebarDotScrollTo();

// Smooth scroll for anchor links
const anchorLinks = document.querySelectorAll('a[href^="#"]:not(.dot)');
anchorLinks.forEach(link => {
	link.addEventListener("click", (e) => {
		e.preventDefault();
		const target = link.getAttribute("href");
		smoothScroll(target);
	});
});

// Smooth scroll on page load if a hash is present in the URL
window.addEventListener("load", () => {
	if (window.location.hash) {
		smoothScroll(window.location.hash);
	}
});






//
// Smooth scroll
// Handle anchor links
//
// var anchorLinks = document.querySelectorAll('a[href*="#"]');
// for (var i = 0; i < anchorLinks.length; i++) {
// 	var link = anchorLinks[i];
// 	if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#0') {
// 		link.addEventListener('click', function(event) {
// 			// On-page links
// 			if (
// 				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
// 				location.hostname == this.hostname
// 			) {
// 			// Figure out element to scroll to
// 			var target = document.querySelector(this.hash);
// 			target = target ? target : document.querySelector('[name=' + this.hash.slice(1) + ']');
// 			// Does a scroll target exist?
// 			if (target) {
// 				// Only prevent default if animation is actually gonna happen
// 				event.preventDefault();
// 				var scrollTop = target.getBoundingClientRect().top + window.pageYOffset - 150;
// 				var duration = 1000;
// 				var easing = function(t) {
// 				return t * (2 - t);
// 				};
// 				var start = window.pageYOffset;
// 				var time = 0;
// 				var animateScroll = function() {
// 				time += 16;
// 				var elapsed = time / duration;
// 				elapsed = elapsed > 1 ? 1 : elapsed;
// 				var eased = easing(elapsed);
// 				var newScrollTop = start + (scrollTop - start) * eased;
// 				window.scrollTo(0, newScrollTop);
// 				if (time < duration) {
// 					window.requestAnimationFrame(animateScroll);
// 				} else {
// 					// Callback after animation
// 					// Must change focus!
// 					var $target = $(target);
// 					$target.focus();
// 					if ($target.is(":focus")) { // Checking if the target was focused
// 					return false;
// 					} else {
// 					$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
// 					$target.focus(); // Set focus again
// 					};
// 				}
// 				};
// 				animateScroll();
// 			}
// 			}
// 		});
// 	}
// }
